import { render, staticRenderFns } from "./PengajuanKegiatanPR.vue?vue&type=template&id=bc5a3b82&scoped=true"
import script from "./PengajuanKegiatanPR.vue?vue&type=script&lang=js"
export * from "./PengajuanKegiatanPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5a3b82",
  null
  
)

export default component.exports